import { Factory } from '../../../lib/api';
const updatePolygonBoundaries = (polygonId, payload) => Factory.patch(`api/v2/polygons/${polygonId}/boundary`, {}, payload);
export default updatePolygonBoundaries;
